import classNames from 'classnames'
import PropTypes from 'prop-types'

import classes from './FilterButton.module.scss'

const FilterButton = ({ onClick, text, isActive = false }) => (
  <button onClick={onClick} className={classNames(classes.filterButton, { [classes.active]: isActive })}>
    {text}
  </button>
)

FilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
}

export default FilterButton
